<lib-gung-dashboard *ngIf="isSales"></lib-gung-dashboard>

<!-- <div class="row">
  <div class="col">
    <a routerLink="/products" [queryParams]="{filters: 'ITEM_GROUP:092'}" class="fp-link">
      <img src="./assets/christmas.jpg" alt="" class="img-fluid">
      <p>Jul</p>
    </a>
  </div>
</div>
<div class="row sm">
  <div class="col">
    <a routerLink="/products" [queryParams]="{filters: 'ITEM_GROUP:091'}" class="fp-link">
      <img src="./assets/bathroom.jpg" alt="" class="img-fluid">
      <p>Bad</p>
    </a>
  </div>
  <div class="col">
      <a routerLink="/products" [queryParams]="{filters: 'ITEM_GROUP:096'}" class="fp-link">
        <img src="./assets/easter.jpg" alt="" class="img-fluid">
        <p>Påsk</p>
      </a>
  </div>
</div>
<div class="row">
  <div class="col">
      <a routerLink="/products" [queryParams]="{filters: 'ITEM_GROUP:094'}" class="fp-link">
        <img src="./assets/kitchen.jpg" alt="" class="img-fluid">
        <p>Kök</p>
      </a>
  </div>
</div> -->
